// URL PELO NOME DO SERVIDOR - USANDO ELA ATUALMENTE
//export const PBIUrlAPI = "http://cloudequipef3-app.pwi.com.br:9101/";
// URL PELO IP DO SERVIDOR
//export const PBIUrlAPI = "http://4.228.56.139:9101/";
// URL COM CERTIFICADO
export const PBIUrlAPI = "https://apibi.pwi.com.br/";
// URL PARA ACESSO AO DEBUG NO LOCAL
//export const PBIUrlAPI = "http://localhost:3105/"

export const URL = {
  URLLogin: "/login",
  URLCadastrarSenha: "/cadastrarsenha",
  URLRecuperarSenha: "/recuperarsenha",
  URLPrimeiroLogin: "/primeirologin",
  URLDashboardMensal: "/dashboardmensal",
  URLDashboardAtual: "/dashboardatual",
};
